import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  Contact,
  Courses,
  About,
  Home,
  Thanks,
  SignUp,
  Course,
  WhyChooseUsPage,
  BlogEvents,
  DigitalSkillsStem,
} from "./pages";

const ConfigRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/thanks" element={<Thanks />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/course/:id" element={<Course />} />
      <Route path="/about" element={<About />} />
      <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
      <Route path="/blog-events" element={<BlogEvents />} />
      <Route path="/digital-skills-stem" element={<DigitalSkillsStem />} />
    </Routes>
  );
};

export default ConfigRoutes;
